export default __webpack_public_path__ + "static/media/storm.f0a83439.png";